import { Text, VFlow } from 'bold-ui'
import React from 'react'

export const renderTextList = (items: string[]) =>
  items?.isNotEmpty() ? (
    <VFlow vSpacing={0.25}>
      {items.map((item, idx) => (
        <Text key={idx} style={{ lineHeight: 0.9 }}>
          {item}
        </Text>
      ))}
    </VFlow>
  ) : (
    <Text>-</Text>
  )
